export interface TakeOffItem {
  unitName: string
  quantity: number
  parentGroup: string
  brand: string
  modelLink: string
  modelLinkName: string
  unitCost: number
  totalCost: number
}

export interface Material {
  count: number
  // area: number, // TODO: Temporary solution
  // cost: number,
  name: string
}

export interface MaterialType {
  name: string
  materials: Material[]
}

export interface MaterialGroup {
  name: string
  materialTypes: MaterialType[]
}

export interface AreaBreakdown {
  id: string
  name: string // TODO: Temporary solution
  // storeyId: string,
  // areaId: string,
  materialGroups: MaterialGroup[]
}

export enum CostStatus {
  Increased = 'INCREASED',
  Decreased = 'DECREASED',
}

export interface Cost {
  value: number
  percentage: number
  status: CostStatus
}

export interface TakeOffCalculation {
  materialBreakdown: AreaBreakdown[] // TODO: Temporary solution
  costPerSqft: number
  energyEfficiency: number
  validationOptimization: number
  totalBuildCost: Cost
  totalMaterialCost: Cost
  totalLaborCost: Cost

  totalSqft: number
}
